import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-year',
	templateUrl: './year.component.html',
	styleUrls: ['./year.component.css']
})
export class YearComponent implements OnInit {
	yearForm: FormGroup;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	yearList: any
	btnTitle: any;
	selectedYearId: any;
	isYearAvailable: boolean = true;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		$(".navbar-brand").text("Year");
		this.yearForm = new FormGroup({
			year: new FormControl("", Validators.compose([
				Validators.required,
			])),
			priority: new FormControl("", Validators.compose([
				Validators.required,
			])),
		});

		this.pageNo = 1;
		this.limit = 10;
		this.getYearList(this.pageNo, this.limit, this.searchStr)
	}

	//Get year list
	getYearList = function (pageNo, limit, searchStr) {

		this.commonService.process();

		this.authService.getYearListPagination(pageNo, limit, searchStr).subscribe(data => {

			if (data.success) {
				this.yearList = data.year;
				this.isYearAvailable = true;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isYearAvailable = false;
				this.yearList = [];
			}
			this.commonService.hideProcess();
		})
	}

	// Pagination
	setPage(page: number, param) {

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.yearList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getYearList(page, this.limit, this.searchStr);
		}
	}

	// Add Year
	addYear = function () {
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add Year";
		this.btnTitle = "Save";
		this.yearForm.reset();
	}

	// Update selected year
	updateSelectedYear = function (year) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update Year";
		this.btnTitle = "Update";
		this.selectedYearId = year._id;
		this.yearForm.controls['year'].setValue(year.year);
		this.yearForm.controls['priority'].setValue(year.priority);
	}

	// Delete Selected year
	deleteSelectedYear = function (year) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Year";
		this.btnTitle = "Yes";
		this.selectedYearId = year._id;
		this.year = year;
	}

	// manage new year
	manageYear = function (yearForm,) {

		if (this.yearForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageYear(yearForm, "add").subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getYearList(1, this.limit, this.searchStr);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.yearForm.valid && this.isActivatedEdit) {
			yearForm._id = this.selectedYearId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageYear(yearForm, "edit", this.selectedYearId).subscribe(data => {
				if (data.success) {
					this.getYearList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
			yearForm._id = this.selectedYearId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageYear(yearForm, "delete", this.selectedYearId).subscribe(data => {
				if (data.success) {

					this.getYearList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.yearForm);
		}
	}

	// Search Year
	searchYear = function () {
		this.searchStr = jQuery("#search").val();
		this.getYearList(1, this.limit, this.searchStr);
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/year/year.component.ts